export default {
	namespaced: true,
	state: () => ({
		type: 1, // 1: openModal 2: 4yuanModal 3: openRetainModal 4: lotteryRetainModal
		userInfo: {}, // 活动用户信息
		modalInfo: {}, // 服务端返回主动弹窗信息
		lotteryResult: {
			// 限时任务开启后接口返回数据
		},
		remainTime: 0, // 任务开启后倒计时 单位：秒
		sharePos: null, // 限时任务发起分享入口位置标记; 'lotteryModal', 'remindModal'
		startCountDown: false, // 是否开启专属任务金倒计时
		lotteryStatus: 0, // 0: 未开始抽奖 1: 抽奖结束
	}),
	mutations: {
		setType(state, data) {
			state.type = data;
		},
		setModalInfo(state, data) {
			state.modalInfo = data;
		},
		setLotteryResult(state, data) {
			state.lotteryResult = data;
		},
		setRemainTime(state, data) {
			state.remainTime = data;
		},
		setSharePos(state, data) {
			state.sharePos = data;
		},
		changeStartCountDown(state, data) {
			state.startCountDown = data;
		},
		setUserInfo(state, data) {
			state.userInfo = data;
		},
		setLotteryStatus(state, data) {
			state.lotteryStatus = data;
		},
	},
	actions: {},
	getters: {
		type(state) {
			return state.type;
		},
		modalInfo(state) {
			return state.modalInfo;
		},
		lotteryResult(state) {
			return state.lotteryResult;
		},
		remainTime(state) {
			return state.remainTime;
		},
		sharePos(state) {
			return state.sharePos;
		},
		startCountDown: (state) => {
			return state.startCountDown;
		},
		userInfo: (state) => {
			return state.userInfo;
		},
		lotteryStatus: (state) => {
			return state.lotteryStatus;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Activity/modules/limit-reward-activity.js